module.exports = __webpack_public_path__ + "static/media/contacts-bg.c9f80b29.jpg";